module.exports = "/images/vendor/flag-icon-css/flags/4x3/mq.svg?bfeadb02a0e0566b376450d23682c523";